import { changePreset } from '@/fsd/shared/api/presets/changePreset';
import { createPreset } from '@/fsd/shared/api/presets/createPreset';
import { deletePreset } from '@/fsd/shared/api/presets/deletePreset';
import { getPresets } from '@/fsd/shared/api/presets/getPresets';
import { useEffect, useState } from 'react';
import { FilterPanelProps, FilterState, Preset } from '../types';

type IProps = {
  table_name: FilterPanelProps['table_name'];
};

export const useSavedFilters = ({ table_name }: IProps) => {
  const [presets, setPresets] = useState<Preset[]>([]);
  const [activePresetId, setActivePresetId] = useState<number>();

  const getSavedFilters = () => {
    return presets.find((preset) => preset.id === activePresetId)?.filters;
  };

  const onPresetDelete = (id: number) => {
    deletePreset(id);
    setPresets((prev) => prev.filter((p) => p.id !== id));
    setActivePresetId(undefined);
  };

  const onPresetCreate = async ({
    name,
    filters,
  }: {
    name: string;
    filters: FilterState;
  }) => {
    const newPreset = await createPreset({
      name,
      filters,
      table_name,
    });
    setPresets((prev) => [...prev, newPreset]);
  };

  const onPresetChange = async ({ id, name }: { id: number; name: string }) => {
    await changePreset({ id, name });
    const changedPresets = presets.map((preset) => {
      if (preset.id === id) preset.name = name;

      return preset;
    });

    setPresets(changedPresets);
  };

  useEffect(() => {
    const fetchGetSavedFilters = async () => {
      const presets = await getPresets();

      const currentPresets = presets.filter(
        (preset) => preset.table_name === table_name
      );
      setPresets(currentPresets);
    };

    fetchGetSavedFilters();
  }, []);

  return {
    presets,
    activePresetId,
    setActivePresetId,
    getSavedFilters,
    onPresetDelete,
    onPresetCreate,
    onPresetChange,
  };
};
